// httpClient.ts
import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import config from '../Config/config.json'

const whatsappURL = config.whatsappUrl;
const xApiKey = config['x-api-key'];

const baseURL = config.apiBaseUrl; // Replace with your API base URL
const httpClient = axios.create({
  baseURL,
});

// Add a function to set the token in the headers
const setAuthToken = (token: string | null): void => {
  if (token) {
    httpClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete httpClient.defaults.headers.common['Authorization'];
  }
};

const get = async function <T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  try {
    const response: AxiosResponse<T> = await httpClient.get<T>(url, config);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching data:', error);
    return error.response?.data || error.message;
  }
};

const post = async function <T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
  try {
    const response: AxiosResponse<T> = await httpClient.post(url, data, config);
    return response.data;
  } catch (error: any) {
    console.error('Error posting data:', error);
    return error.response?.data || error.message;
  }
};

const del = async function <T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  try {
    const response: AxiosResponse<T> = await httpClient.delete(url, config);
    return response.data;
  } catch (error: any) {
    console.error('Error deleting data:', error);
    return error.response?.data || error.message;
  }
};
const put = async function <T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
  try {
    const response: AxiosResponse<T> = await httpClient.put<T>(url, data, config);
    return response.data;
  } catch (error: any) {
    console.error('Error putting data:', error);
    return error.response?.data || error.message;
  }
};


const sendMessage = async function <T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
  try {
    const response: AxiosResponse<T> = await axios.create({
      baseURL: whatsappURL,
      headers: {
        "x-api-key": xApiKey,
        "Content-Type": "application/json"
      }
    }).post(url, data, config);
    return response.data;
  } catch (error) {
    console.error('Error sending otp:', error);
    throw error;
  }
};

// Dedicated function for posting FormData
const postFormData = async function <T>(
  url: string,
  formData: FormData, // Explicitly expect FormData
  config?: AxiosRequestConfig
): Promise<T> {
  try {
    const response: AxiosResponse<T> = await httpClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Set FormData-specific header
        ...config?.headers, // Merge custom headers if provided
      },
      ...config, // Spread other configurations
    });

    return response.data;
  } catch (error: any) {
    console.error("Error posting FormData:", error);
    return error.response?.data || error.message;
  }
};
const putFormData = async function <T>(
  url: string,
  formData: FormData, // Explicitly expect FormData
  config?: AxiosRequestConfig
): Promise<T> {
  try {
    const response: AxiosResponse<T> = await httpClient.put(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Set FormData-specific header
        ...config?.headers, // Merge custom headers if provided
      },
      ...config, // Spread other configurations
    });

    return response.data;
  } catch (error: any) {
    console.error("Error updating FormData:", error);
    return error.response?.data || error.message;
  }
};

const patch = async function <T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
  try {
    const response: AxiosResponse<T> = await httpClient.patch<T>(url, data, config);
    return response.data;
  } catch (error: any) {
    console.error('Error patching data:', error);
    return error.response?.data || error.message;
  }
};

const http = {
  get,
  post,
  del,
  put,
  setAuthToken,
  postFormData,
  putFormData,
  patch,
  sendMessage
};

export default http;
